<details-section
  title="Simulation Details"
  [showDetails]="true"
  [detailsText]="'Preview simulation details modal'"
  (actionClicked)="previewModal()"
  [actiondisabled]="previewModalButtonState"
  [description]="simulationDetailsSectionDescription"
>

  <div class="container" [formGroup]="form">
    <div class="container" formArrayName="simulationDetailtabs">
      <div
        *ngFor="let tab of simulationDetailtabs.controls; let i = index"
        [formGroupName]="i"
      >
        <qai-field [label]="tab.get('tabTitle')?.value">
          <textarea
            qai-textarea
            autosize
            [maxLines]="30"
            qaiTrimLeading
            qaiPasteClean
            formControlName="tabText"
          ></textarea>
        </qai-field>
      </div>
    </div>

    <qai-field [label]="'Additional section title'">
      <input qai-input type="text" qaiTrimLeading formControlName="additionalSectionTitle" />
    </qai-field>

    <qai-field [label]="'Additional section information'">
      <textarea
        qai-textarea
        autosize
        [maxLines]="30"
        qaiTrimLeading
        qaiPasteClean
        formControlName="additionalSectionInfo"
      ></textarea>
    </qai-field>
  </div>
</details-section>


<preview-simulations-details-modal
  [open]="openPreviewModal"
  [tabs]="previewTabs"
  (closeModal)="handleModalClose()"
></preview-simulations-details-modal>
